import format from "date-fns/format";

export default dateTime => (dateTime ? format(dateTime, "dd-MMM-yyyy") : "N/A");
